import React from 'react';
import MuiPopper, { PopperProps } from '@material-ui/core/Popper';

const Popper = (props: PopperProps) => {
  return (
    <MuiPopper {...props}>
      {props.children}
    </MuiPopper>
  );
};

export default Popper;
